module.exports = __webpack_public_path__ + "img/thumbnail_Hippopotamus_m_normal.7f0227ce.png";